import { render } from "./LeadAreaAdd.vue?vue&type=template&id=842d911c"
import script from "./LeadAreaAdd.vue?vue&type=script&lang=js"
export * from "./LeadAreaAdd.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__